import { Action } from '@ngrx/store';
import { ITestDriveVehicleInventory, ISyncStatus, SourceSystem } from '@signal/asp-data-commons';

export enum VehiclesActionTypes {
    ADD_VEHICLE = '[Vehicles] Add Vehicle',
    ADD_VEHICLE_SUCCESS = '[Vehicles] Add Vehicle success',
    ADD_VEHICLE_FAILURE = '[Vehicles] Add Vehicle failure',
    LOAD_VEHICLES = '[Vehicles] Load Vehicles',
    LOAD_VEHICLES_SUCCESS = '[Vehicles] Load Vehicles success',
    LOAD_VEHICLES_FAILURE = '[Vehicles] Load Vehicles failure',
    LOAD_ALL_VEHICLES = '[Vehicles] Load All Vehicles',
    LOAD_ALL_VEHICLES_SUCCESS = '[Vehicles] Load All Vehicles success',
    LOAD_ALL_VEHICLES_FAILURE = '[Vehicles] Load All Vehicles failure',
    UPDATE_VEHICLE = '[Vehicles] Update Vehicle',
    UPDATE_VEHICLE_SUCCESS = '[Vehicles] Update Vehicle success',
    UPDATE_VEHICLE_FAILURE = '[Vehicles] Update Vehicle failure',
    DELETE_VEHICLE = '[Vehicles] Delete Vehicle',
    DELETE_VEHICLE_SUCCESS = '[Vehicles] Delete Vehicle success',
    DELETE_VEHICLE_FAILURE = '[Vehicles] Delete Vehicle failure',
    LOAD_SEARCH_VEHICLES = '[Vehicles] Load Search Vehicles',
    UPDATE_FROM_CRM = '[Vehicles] Load All Vehicles from CRM',
    UPDATE_FROM_CRM_SUCCESS = '[Vehicles] Load All Vehicles from CRM success',
    UPDATE_FROM_CRM_FAILURE = '[Vehicles] Load All Vehicles from CRM failure',
    LOAD_SYNC_STATUS = '[Vehicles] Load sync status',
    LOAD_SYNC_STATUS_SUCCESS = '[Vehicles] Load sync status success',
    LOAD_SYNC_STATUS_FAILURE = '[Vehicles] Load sync status failure',
    RESTORE_VEHICLE = '[Vehicles] Restore Vehicle',
    RESTORE_VEHICLE_SUCCESS = '[Vehicles] Restore Vehicle success',
    RESTORE_VEHICLE_FAILURE = '[Vehicles] Restore Vehicle failure',
    UPDATE_NVI_STATUS = '[Vehicles] Update nvi status',
    UPDATE_NVI_STATUS_SUCCESS = '[Vehicles] Update nvi status success',
    UPDATE_NVI_STATUS_FAILURE = '[Vehicles] Update nvi status failure',
    UPDATE_UVI_STATUS = '[Vehicles] Update uvi status',
    UPDATE_UVI_STATUS_SUCCESS = '[Vehicles] Update uvi status success',
    UPDATE_UVI_STATUS_FAILURE = '[Vehicles] Update uvi status failure',
    UPDATE_BULK_VEHICLE_STATUS = '[Vehicles] Update bulk vehicle status',
    UPDATE_BULK_VEHICLE_STATUS_SUCCESS = '[Vehicles] Update bulk vehicle status success',
    UPDATE_BULK_VEHICLE_STATUS_FAILURE = '[Vehicles] Update bulk vehicle status failure',
    FETCH_VEHICLES_FROM_SOURCE = '[Vehicles] fetch data based on source',
    FETCH_VEHICLES_FROM_SOURCE_SUCCESS = '[Vehicles] fetch data based on source success',
    FETCH_VEHICLES_FROM_SOURCE_FAILURE = '[Vehicles] fetch data based on source failure',
    RESET_VEHICLE_STATE = '[Vehicles] reset vehicle state'
}

export class AddVehicle implements Action {
    readonly type: string = VehiclesActionTypes.ADD_VEHICLE;

    constructor(public payload: { vehicle: ITestDriveVehicleInventory }) {
    }
}

export class AddVehicleSuccess implements Action {
    readonly type: string = VehiclesActionTypes.ADD_VEHICLE_SUCCESS;

    constructor(public payload: { vehicle: ITestDriveVehicleInventory }) {
    }
}

export class AddVehicleFailure implements Action {
    readonly type: string = VehiclesActionTypes.ADD_VEHICLE_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadVehicles implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_VEHICLES;

    constructor(public payload: {offset: number, limit: number}) {
    }
}

export class LoadVehiclesSuccess implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_VEHICLES_SUCCESS;

    constructor(public payload: { vehicles: any }) {
    }
}

export class LoadVehiclesFailure implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_VEHICLES_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadAllVehicles implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_ALL_VEHICLES;

    constructor(public payload: {view: string} ) {
    }
}

export class LoadAllVehiclesSuccess implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_ALL_VEHICLES_SUCCESS;

    constructor(public payload: { vehicles: any }) {
    }
}

export class LoadAllVehiclesFailure implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_ALL_VEHICLES_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateNVIStatus implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_NVI_STATUS;

    constructor(public payload: { vehicle:ITestDriveVehicleInventory}) {
    }
}

export class UpdateNVIStatusSuccess implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_NVI_STATUS_SUCCESS;

    constructor(public payload: { vehicle: ITestDriveVehicleInventory}) {
    }
}

export class UpdateNVIStatusFailure implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_NVI_STATUS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateUVIStatus implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_UVI_STATUS;

    constructor(public payload: { vehicle:ITestDriveVehicleInventory}) {
    }
}

export class UpdateUVIStatusSuccess implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_UVI_STATUS_SUCCESS;

    constructor(public payload: { vehicle: ITestDriveVehicleInventory}) {
    }
}

export class UpdateUVIStatusFailure implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_UVI_STATUS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateBulkVehicleStatus implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_BULK_VEHICLE_STATUS;

    constructor(public payload: { requestedVehicles: any[]; payload: any[]; status: boolean; source: string }) {
    }
}

export class UpdateBulkVehicleStatusSuccess implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_BULK_VEHICLE_STATUS_SUCCESS;

    constructor(public payload: { requestedVehicles: any[]; records: any[] }) {
    }
}

export class UpdateBulkVehicleStatusFailure implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_BULK_VEHICLE_STATUS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateVehicle implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_VEHICLE;

    constructor(public payload: { vehicle: ITestDriveVehicleInventory, isLoadNotification?: boolean}) {
    }
}

export class UpdateVehicleSuccess implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_VEHICLE_SUCCESS;

    constructor(public payload: { vehicle: ITestDriveVehicleInventory }) {
    }
}

export class UpdateVehicleFailure implements Action {
    readonly type: string = VehiclesActionTypes.UPDATE_VEHICLE_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class DeleteVehicle implements Action {
    readonly type: string = VehiclesActionTypes.DELETE_VEHICLE;

    constructor(public payload: { vehicles: any[] }) {
    }
}

export class DeleteVehicleSuccess implements Action {
    readonly type: string = VehiclesActionTypes.DELETE_VEHICLE_SUCCESS;

    constructor(public payload: { requestedVehicles: any[], response : any[] }) {
    }
}

export class DeleteVehicleFailure implements Action {
    readonly type: string = VehiclesActionTypes.DELETE_VEHICLE_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadSearchVehicles implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_SEARCH_VEHICLES;

    constructor(public payload: {searchConfig : any, view: string}) {
    }
}

export class UpdateFromCrm implements Action {
    readonly type = VehiclesActionTypes.UPDATE_FROM_CRM;
  
    constructor() {
    }
  }
  
  export class UpdateFromCrmSuccess implements Action {
    readonly type = VehiclesActionTypes.UPDATE_FROM_CRM_SUCCESS;
  
    constructor(public payload: { status: ISyncStatus }) {
    }
  }
  
  export class UpdateFromCrmFailure implements Action {
    readonly type = VehiclesActionTypes.UPDATE_FROM_CRM_FAILURE;
  
    constructor(public payload: { error: string }) {
    }
  }

  export class LoadSyncStatus implements Action {
    readonly type: string = VehiclesActionTypes.LOAD_SYNC_STATUS;
  
    constructor() {
    }
  }
  
  export class LoadSyncStatusSuccess implements Action {
    readonly type = VehiclesActionTypes.LOAD_SYNC_STATUS_SUCCESS;
  
    constructor(public payload: { status: ISyncStatus }) {
  
    }
  }
  
  export class LoadSyncStatusFailure implements Action {
    readonly type = VehiclesActionTypes.LOAD_SYNC_STATUS_FAILURE;
  
    constructor(public payload: { error: string }) {
  
    }
  }

  export class RestoreVehicle implements Action {
    readonly type: string = VehiclesActionTypes.RESTORE_VEHICLE;

    constructor(public payload: { vehicles: any[] }) {
    }
}

export class RestoreVehicleSuccess implements Action {
    readonly type: string = VehiclesActionTypes.RESTORE_VEHICLE_SUCCESS;

    constructor(public payload: { vehicles : any[] }) {
    }
}

export class RestoreVehicleFailure implements Action {
    readonly type: string = VehiclesActionTypes.RESTORE_VEHICLE_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class FetchVehiclesBasedOnSource implements Action{
    readonly type: string = VehiclesActionTypes.FETCH_VEHICLES_FROM_SOURCE;

    constructor(public payload:{source:string}){

    }
}

export class FetchVehiclesBasedOnSourceSuccess implements Action{
    readonly type: string = VehiclesActionTypes.FETCH_VEHICLES_FROM_SOURCE_SUCCESS;

    constructor(public payload:{vehicles : any}){
        
    }
}

export class FetchVehiclesBasedOnSourceFaliure implements Action{
    readonly type: string = VehiclesActionTypes.FETCH_VEHICLES_FROM_SOURCE_FAILURE;

    constructor(public payload:{error: string}){
        
    }
}

export class ResetVehicleState implements Action {
    readonly type: string = VehiclesActionTypes.RESET_VEHICLE_STATE;

}
  

export type VehiclesActions =
    AddVehicle
    | AddVehicleSuccess
    | AddVehicleFailure
    | LoadVehicles
    | LoadVehiclesSuccess
    | LoadVehiclesFailure
    | LoadAllVehicles
    | LoadAllVehiclesSuccess
    | LoadAllVehiclesFailure
    | UpdateVehicle
    | UpdateVehicleSuccess
    | UpdateVehicleFailure
    | DeleteVehicle
    | DeleteVehicleSuccess
    | DeleteVehicleFailure
    | UpdateFromCrm
    | UpdateFromCrmSuccess
    | UpdateFromCrmFailure
    | RestoreVehicle
    | RestoreVehicleSuccess
    | RestoreVehicleFailure
    | LoadSyncStatus
    | LoadSyncStatusSuccess
    | LoadSyncStatusFailure
    | UpdateNVIStatus
    | UpdateNVIStatusSuccess
    | UpdateNVIStatusFailure
    | UpdateUVIStatus
    | UpdateUVIStatusSuccess
    | UpdateUVIStatusFailure
    | UpdateBulkVehicleStatus
    | UpdateBulkVehicleStatusSuccess
    | UpdateBulkVehicleStatusFailure
    | FetchVehiclesBasedOnSource
    | FetchVehiclesBasedOnSourceSuccess
    | FetchVehiclesBasedOnSourceFaliure
    | ResetVehicleState